// Validadores puros e regionalizados para formularios do MecSync.
// Regras internacionais compartilhadas + regras especificas do Brasil.
// Nao misturar mascara (src/utils/masks.js) com validacao.

export function onlyDigits(value = '') {
  return String(value).replace(/\D/g, '');
}

function hasRepeatedDigits(value) {
  return /^(\d)\1+$/.test(value);
}

// CPF: 11 digitos com digito verificador.
export function isValidCpf(value) {
  const cpf = onlyDigits(value);
  if (cpf.length !== 11 || hasRepeatedDigits(cpf)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i += 1) sum += Number(cpf[i]) * (10 - i);
  let check = (sum * 10) % 11;
  if (check === 10) check = 0;
  if (check !== Number(cpf[9])) return false;

  sum = 0;
  for (let i = 0; i < 10; i += 1) sum += Number(cpf[i]) * (11 - i);
  check = (sum * 10) % 11;
  if (check === 10) check = 0;
  return check === Number(cpf[10]);
}

// CNPJ: 14 digitos com digito verificador.
export function isValidCnpj(value) {
  const cnpj = onlyDigits(value);
  if (cnpj.length !== 14 || hasRepeatedDigits(cnpj)) return false;

  const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  let sum = 0;
  for (let i = 0; i < 12; i += 1) sum += Number(cnpj[i]) * weights1[i];
  let check = sum % 11;
  check = check < 2 ? 0 : 11 - check;
  if (check !== Number(cnpj[12])) return false;

  const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  sum = 0;
  for (let i = 0; i < 13; i += 1) sum += Number(cnpj[i]) * weights2[i];
  check = sum % 11;
  check = check < 2 ? 0 : 11 - check;
  return check === Number(cnpj[13]);
}

// Documento brasileiro: aceita CPF ou CNPJ validos.
export function isValidDocumentBR(value) {
  return isValidCpf(value) || isValidCnpj(value);
}

// Telefone regionalizado.
// Brasil: 10 ou 11 digitos (inclui DDD).
// Outros paises: mantem validacao internacional (>= 7 digitos).
export function isValidPhone(value, countryCode = 'BR') {
  const digits = onlyDigits(value);
  if (countryCode === 'BR') return digits.length === 10 || digits.length === 11;
  return digits.length >= 7;
}

export function isValidEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
}

// CEP regionalizado: Brasil exige 8 digitos; demais aceitam qualquer valor nao vazio.
export function isValidCep(value, countryCode = 'BR') {
  const digits = onlyDigits(value);
  if (countryCode === 'BR') return digits.length === 8;
  return String(value || '').trim().length > 0;
}

// Placa de veiculo regionalizada.
// Brasil: formato antigo ABC1234 ou Mercosul ABC1D23.
// Outros paises: aceita qualquer registro nao vazio (label via vehicleRegistrationLabel).
export function isValidPlate(value, countryCode = 'BR') {
  if (countryCode !== 'BR') return hasValue(value);
  const alphanumeric = String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  if (alphanumeric.length !== 7) return false;
  return /^[A-Z]{3}[0-9]{4}$/.test(alphanumeric) || /^[A-Z]{3}[0-9][A-Z][0-9]{2}$/.test(alphanumeric);
}

// Verifica se um campo preenchido tem valor util (nao somente espacos).
export function hasValue(value) {
  return String(value || '').trim().length > 0;
}
